import { create } from "zustand";
import { persist } from "zustand/middleware";

// Phase 7b₂ᵦ — shared safety store. Both /outreach dashboard Account health and
// /outreach/sequences/:id Pacing & Safety read/write from here so changes ripple live.
export const useSafetyStore = create(
  persist(
    (set) => ({
      caps: {
        whatsapp: { current: 32, cap: 50, platformLimit: 80, label: "Aman's WhatsApp" },
        linkedin: { current: 18, cap: 25, platformLimit: 100, label: "Aman's LinkedIn" },
        linkedinDms: { current: 26, cap: 50, platformLimit: 100, label: "Aman's LinkedIn — DMs" },
        gmail: { current: 64, cap: 100, platformLimit: 200, label: "Aman's Gmail" },
        telegram: { current: 14, cap: 50, platformLimit: 100, label: "Aman's Telegram" },
        sms: { current: 8, cap: 40, platformLimit: 80, label: "Aman's SMS" },
      },
      jitterEnabled: true,
      quietHoursStart: "22:00",
      quietHoursEnd: "07:00",
      warmupPreset: "standard",
      tosAccepted: false,
      tosByChannel: { whatsapp: false, linkedin: false, gmail: false },
      setCap: (key, cap) => set((s) => ({ caps: { ...s.caps, [key]: { ...s.caps[key], cap } } })),
      setJitter: (v) => set({ jitterEnabled: v }),
      setQuietHours: (start, end) => set({ quietHoursStart: start, quietHoursEnd: end }),
      setWarmupPreset: (p) => set({ warmupPreset: p }),
      setTosAccepted: (v) => set((s) => ({
        tosAccepted: v,
        tosByChannel: { whatsapp: v, linkedin: v, gmail: v },
      })),
      setTosForChannel: (channelId, v) => set((s) => {
        const next = { ...s.tosByChannel, [channelId]: v };
        const allAccepted = Object.values(next).every(Boolean);
        return { tosByChannel: next, tosAccepted: allAccepted };
      }),
    }),
    {
      name: "sellix.safety.v1",
      migrate: (persistedState, version) => {
        // Migrate legacy localStorage key for TOS ack
        if (persistedState && typeof persistedState.tosAccepted === "undefined") {
          try {
            const legacy = localStorage.getItem("sellix.pacing.tos.ack.v1");
            if (legacy === "1") persistedState.tosAccepted = true;
          } catch { /* noop */ }
        }
        // Phase 9 — split single tosAccepted into per-channel map
        if (persistedState && !persistedState.tosByChannel) {
          const v = !!persistedState.tosAccepted;
          persistedState.tosByChannel = { whatsapp: v, linkedin: v, gmail: v };
        }
        return persistedState;
      },
    },
  ),
);
